import { Model } from '../general'

import { FloorplanData } from '.'

export interface Data extends Pick<FloorplanData, 'floorplan'> {
  id: number
  company_id: number
  building_id: number
  number?: number
  name?: string
  nr_of_workspaces?: number
}

class Floor extends Model<Data> {
  get companyId() {
    return this.data.company_id
  }

  get buildingId() {
    return this.data.building_id
  }

  get number() {
    return this.data.number
  }

  get name() {
    return this.data.name
  }

  get displayName() {
    return this.data.name || `${this.data.number}`
  }

  get searchText(): string {
    return `${this.number} ${this.name}`
  }

  get floorplanBackground() {
    return this.data.floorplan?.background
  }

  get floorplanScale() {
    return this.data.floorplan?.scale
  }

  get numberOfWorkspaces() {
    return this.data.nr_of_workspaces || 0
  }
}

export default Floor
